import { apiAxios } from '../../../helpers'
import vuetifyToast from 'vuetify-toast'
import FormData from 'form-data'

export const setCreate = async advertising => {
  let photo = advertising.file
  delete advertising.file

  const result = await apiAxios.post('advertising/create', advertising)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
  if (photo) {
    let resAdvertising = result.data.data.advertising
    await uploadFile(resAdvertising, photo)
  }
}

export const setUpdate = async advertising => {
  let photo = null
  if (advertising.file) {
    photo = advertising.file
    delete advertising.file
  }
  const result = await apiAxios.put(
    'advertising/' + advertising._id,
    advertising
  )
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
  if (photo) {
    let resAdvertising = result.data.data.advertising
    await uploadFile(resAdvertising, photo)
  }
}

const setUpdateWithPhoto = async advertising => {
  const result = await apiAxios.put(
    'advertising/' + advertising._id,
    advertising
  )
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}

export const setDelete = async id => {
  const result = await apiAxios.delete('advertising/' + id)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'success',
    timeout: 2000,
    icon: 'warning'
  })
}

const uploadFile = async (advertising, photo) => {
  let file = new FormData()
  file.append('file', photo)

  const result = await apiAxios.post('/upload/file', file, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  advertising.img = result.data.data.file.filename
  console.log(result.data.data.file)
  await setUpdateWithPhoto(advertising)
  vuetifyToast.show({
    text: result.data.message.reason,
    color: 'info',
    timeout: 2000,
    icon: 'warning'
  })
}
